import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';

interface FooterProps {
  children: ReactNode;
  className?: string;
  itemVariants?: any;
}

export const Footer: React.FC<FooterProps> = ({
  children,
  className = '',
  itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  },
}) => {
  return (
    <motion.footer 
      className={`footer_section py-20 sm:py-24 bg-white border-t border-gray-200 ${className}`} 
      variants={itemVariants}
    >
      <div className="page-padding">
        <div className="container-medium">
          <div className="footer_content">
            {children}
          </div>
        </div>
      </div>
    </motion.footer>
  );
};
